import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
// import { IoDocumentTextOutline } from "react-icons/io5";
import { TbReportSearch } from "react-icons/tb";
import "../../borrowSystem/Report/ListReports.css"

export function ListReportSupportSubmitRequestComponent() {
    return(
        <Container>
            <div className="d-flex flex-wrap justify-content-center align-items-center ">
                
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/Form/transferforofficer"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 12)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/Form/transferforofficer13"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 13)</p>
                    </Link>
                </div>
               
                
            </div>
            <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
        </Container>
    )
}